import { render } from "./TrainingRncpSourceDetailsComponent.vue?vue&type=template&id=1dad10b5&scoped=true"
import script from "./TrainingRncpSourceDetailsComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpSourceDetailsComponent.vue?vue&type=script&lang=js"

import "./TrainingRncpSourceDetailsComponent.vue?vue&type=style&index=0&id=1dad10b5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dad10b5"]])

export default __exports__